import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import service_studies from 'services/studies';

/** @typedef {number} UseArchiveStudyMutationVariables - Study ID */

/** @typedef {Omit<UseMutationOptions<Object, Error, UseArchiveStudyMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseArchiveStudyMutationOptions */

/**
 * @param {UseArchiveStudyMutationOptions} [options={}]
 */
export const useArchiveStudyMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['archive-study'],
        /** @param {UseArchiveStudyMutationVariables} studyId */
        mutationFn: studyId => service_studies.archiveStudy(studyId)
    });
};
